module.exports = __webpack_public_path__ + "img/DE00797.04ac0e47.png";